import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastComponent } from '../toast.component';
import { ToastService } from '../toast-service/toast-service';

@Component({
  selector: 'ef-toast-wrapper',
  standalone: true,
  imports: [ToastComponent],
  templateUrl: './toast-wrapper.component.html',
  styleUrl: './toast-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastWrapperComponent {
  readonly stateService = inject(ToastService);
}
